import NetPromoterScoreModal from './NetPromoterScoreModal'
export default NetPromoterScoreModal